import * as React from 'react';
import { ResponsiveContainer, LineType, Margin, XPadding } from 'recharts';
import { CONSTANTS } from '../../../assets/UIConstants';
import { AreaGraph } from './AreaGraph';
import { Comparision } from '../../pages/Public';

interface IDataPoint {
    x: number;
    y: number;
}

interface Props {
    dataPoints: IDataPoint[];
    width?: number;
    height?: number;
    hasGrid?: boolean;
    accentColor?: string;
    dotRadius?: number;
    lineWidth?: number;
    type?: LineType;
    margin?: Partial<Margin>;
    padding?: XPadding;
    xAxisTickFormatter?: (value: number) => string;
    goodValueComparisionValue?: number;
    goodValueComparision?: Comparision;
    showYAxis: boolean;
}

export class FullSummaryGraph extends AreaGraph {

    public static defaultProps: Partial<Props> = {
        hasGrid: true,
        accentColor: CONSTANTS.COLORS.THEME_BLUE,
        lineWidth: 2,
        dotRadius: 8
    };

    public render(): JSX.Element {
        return (
            <ResponsiveContainer>
                {this.renderGraph()}
            </ResponsiveContainer>
        );
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/views/components/Graphs/FullSummaryGraph.tsx